import React, {useRef} from "react";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {logout, refreshToken} from "@commons/actions/authentication.action";
import {selectTokenID} from "@commons/core.slice";
import {IconAlertTriangle, IconDoorExit} from "@tabler/icons-react";

interface SessioneInScadenzaProps {

}

const SessioneInScadenza: React.FC<SessioneInScadenzaProps> = () => {
    const dispatch = useAppDispatch();
    const token = useAppSelector(selectTokenID);
    const cancelButtonRef = useRef(null)
    const rimaniCollegato = () => dispatch(refreshToken(token!));
    const scollegati = () => dispatch(logout(token!));

    return (
        <div className="overflow-hidden rounded-lg bg-white text-left shadow-xl sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
                        <IconAlertTriangle className="h-6 w-6 text-yellow-600" aria-hidden="true"/>
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 className="text-lg font-medium leading-6">
                            Sessione in scadenza
                        </h3>
                        <div className="mt-2">
                            <p className="text-sm text-gray-500">
                                La tua sessione st&agrave; per scadere, a breve verrai scollegato.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={scollegati}>
                    Logout&nbsp;<IconDoorExit size={19}/>
                </button>

                <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={rimaniCollegato}
                    ref={cancelButtonRef}
                >
                    Rimani collegato
                </button>
            </div>
        </div>
    )
}
export default SessioneInScadenza;